import { UserDashboardItemResultDto } from './user-dashboard-item-result-dto';

export class UserDashboardByCommunityResultDto extends UserDashboardItemResultDto {
    community: string;
    communityId: number;
    location: string;
}
